// extracted by mini-css-extract-plugin
export var container = "about-module--container--102FP";
export var imageWrapper = "about-module--image-wrapper--3fugP";
export var text = "about-module--text--1xvRJ";